/* eslint-disable */

/** unique or primary key constraints on table "argo.udf_column" */
export enum ArgoUdfColumnConstraint {
  /** unique or primary key constraint on columns "udf_column_id", "type" */
  UdfColumnEnforceUniqueFk = 'udf_column_enforce_unique_fk',
  /** unique or primary key constraint on columns "udf_column_id" */
  UdfColumnPkey = 'udf_column_pkey'
}

/** select columns of table "argo.udf_column" */
export enum ArgoUdfColumnSelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataType = 'data_type',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required',
  /** column name */
  ValidationUnique = 'validation_unique'
}

/** select "argo_udf_column_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.udf_column" */
export enum ArgoUdfColumnSelectColumnArgoUdfColumnAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** select "argo_udf_column_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.udf_column" */
export enum ArgoUdfColumnSelectColumnArgoUdfColumnAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Enabled = 'enabled',
  /** column name */
  ValidationRequired = 'validation_required'
}

/** update columns of table "argo.udf_column" */
export enum ArgoUdfColumnUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  DataType = 'data_type',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Name = 'name',
  /** column name */
  NameUnique = 'name_unique',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  ValidationMax = 'validation_max',
  /** column name */
  ValidationMin = 'validation_min',
  /** column name */
  ValidationPattern = 'validation_pattern',
  /** column name */
  ValidationRequired = 'validation_required',
  /** column name */
  ValidationUnique = 'validation_unique'
}

